module.exports = __webpack_public_path__ + "img/telegraphs.fe687e53.gif";